import { Col, Row, Typography } from "antd";
import React, { FC, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import styled from "styled-components";
import { SmallText } from "../../../Components/Text3D";
import {} from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import Channels from "../../../Components/Channels";
import MessageX from "../../../Components/Message";
import { getUserId } from "../../../utils/utilsFunctions";

const InboxWrapper = styled.div`
  .inbox-message {
    text-align: center;
    margin-bottom: 6px;
  }
`

const MainWrapper = styled.div`
  background-color: #f7f7f7;
  font-family: "Planer";
  display: flex;
  flex-direction: column;
  border: 1px solid #d8d8d8;
  .message-search {
    background: transparent;
    border: 1px solid #d8d8d8;
    border-radius: 24px;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 10px;
    margin-bottom: 20px;
    .cs-search__search-icon {
      color: rgba(0, 0, 0, 0.5);
    }
    .cs-search__input {
      background: transparent;
      font-size: 0.875rem;
      padding: 0px 1rem;
      line-height: 1.15;
    }
  }
  .cs-conversation{
    .cs-avatar {
      border: 1px solid #d8d8d8;
      padding: 4px;
    }
  }
  .cs-message-input__content-editor-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border: 1px solid #d8d8d8;
    border-radius: 24px;
    .cs-message-input__content-editor-container{
      background-color: transparent;
      .cs-message-input__content-editor {
        background-color: transparent;
      }
    }
  }
  .cs-button {
    color: #1890ff;
  }
`;
const ContentSection = styled(Col)`
  background: white;
`;
const TopBar = styled(Row)`
  display: flex;
  border-bottom: 1px solid #d8d8d8;
`;
const TopBarContent = styled(Col)``;
const UserSection = styled(Col)`
  padding: 0.5rem;
  height: 450px;
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const MessageSection = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  height: 450px;
  overflow: scroll;

  ::-webkit-scrollbar {
    display: none;
  }
  .cs-main-container {
    border: none;
    border-left: 1px solid #d8d8d8;
    .cs-message--outgoing{
      .cs-message__content {
        background-color: #1890ff;
        color: #FFFFFF;
      }
    }
    .cs-message--incoming{
      .cs-message__content {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
  }
`;
// const SectionRight = styled.section`
//   margin: 1rem;
//   display: flex;
//   flex-direction: column;
// `;
// const Span = styled.span`
//   font-size: 14px;
//   line-height: 17px;
//   font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
//   margin: 0.2rem 0;
//   display: flex;
//   align-items: center;
// `;

// const Small = styled.span`
//   font-size: 14px;
//   line-height: 20px;
//   font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
//   padding-left: 0.8rem;
// `;

const InboxPage: FC = () => {
  const userId = getUserId();
  const [currentChat, setCurrentChat] = useState<any>(null);
  const [otherMember, setOtherMember] = useState<any>(null);

  useEffect(() => {
    if (currentChat && currentChat.members) {
      const otherMember = currentChat?.members.find(
        (m: any) => m._id !== userId
      );
      const name = `${otherMember?.firstName} ${otherMember?.lastName || ""}`;
      setOtherMember({ ...otherMember, name });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat]);

  return (
    <InboxWrapper>
      <div className="inbox-message">
        <Typography.Text type="secondary">
        <InfoCircleTwoTone /> "For your protection and safety, always communicate through 3Dprintit"
        </Typography.Text>
      </div>
    <MainWrapper>
      <ContentSection>
        <TopBar>
          <TopBarContent span={8}>
            <Typography
              style={{ padding: "2rem", borderRight: "1px solid #D8D8D8" }}
            >
              <SmallText small size line bold style={{ textAlign: "center" }}>
              Messages
              </SmallText>
            </Typography>
          </TopBarContent>
          <TopBarContent span={16} style={{ padding: "2rem" }}>
            <SmallText small size bold>
              {otherMember?.name}
            </SmallText>
          </TopBarContent>
        </TopBar>
        <Row>
          <Col span={8}>
            <UserSection>
              <Channels
                setCurrentChat={setCurrentChat}
                currentChat={currentChat}
              />
            </UserSection>
          </Col>
          <Col span={16}>
            <div style={{ width: "100%", position: "relative" }}>
              <MessageSection>
                <MessageX currentChat={currentChat} />
              </MessageSection>
            </div>
          </Col>
          {/* <Col span={6}>
            {otherMember && (
              <SectionRight>
                <Span>
                  <strong>About:</strong>
                  <Small>{otherMember?.name}</Small>
                </Span>
                <Span>
                  <strong>Joint on:</strong>
                  <Small>{otherMember?.createdAt}</Small>
                </Span>
                <Span>
                  <strong style={{ marginTop: "3px" }}>Total Likes:</strong>
                  <Small>{otherMember?.totalLikes}</Small>
                </Span>
              </SectionRight>
            )}
          </Col> */}
        </Row>
      </ContentSection>
    </MainWrapper>
    </InboxWrapper>
  );
};

export default InboxPage;
